import axios from 'axios';

// export const API_BASE_URL = 'http://120.79.175.101:8000';
// export const API_BASE_URL = 'http://127.0.0.1:8000';

export const API_BASE_URL = "https://api.ennovels.com";

// export const API_BASE_URL = 'http://192.168.79.28:8000';
// export const API_BASE_URL = 'http://192.168.79.96:8000';

// export const API_BASE_URL = 'http://192.168.18.67:8000';

// 创建axios实例
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,  // 增加到30秒，特殊请求可以单独设置更长的timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

export const withApiPrefix = (rawPath = '') => {
  const trimmed = typeof rawPath === 'string' ? rawPath.trim() : '';
  if (!trimmed) {
    return '/api';
  }
  const normalized = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  if (normalized === '/api' || normalized.startsWith('/api/')) {
    return normalized;
  }
  return `/api${normalized}`;
};

// 请求拦截器 - 添加认证token
api.interceptors.request.use(
  (config) => {
    if (typeof config.url === 'string' && !config.url.startsWith('http')) {
      config.url = withApiPrefix(config.url);
    }
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理错误
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token过期或无效，清除本地存储并重定向到登录页
      localStorage.removeItem('token');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api;
